export default {
    title: 'Bloem en groen voor op kantoor',
    body1: '- Wekelijks duurzame en stijlvolle boeketten voor op kantoor',
    body2: '- Duurzame wensboeketten voor zakenrelaties en collega\'s',
    body3: '- Verfrissen van jouw werkruimte met groene kantoorplanten',
    button: 'Lees hier meer',
};